import { createSlice, PayloadAction } from '@reduxjs/toolkit'; // Adjust the import path
import type { IDialogData, IDialogState } from '../../../types';
import { ECommonDialogType } from '../../data/Constants';

const initialState: IDialogState = {
  show: false,
  type: ECommonDialogType.Unknown,
  data: null,
  title: '',
  handleClickOk: () => undefined,
};

const DialogSlice = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    openDialog(state, action: PayloadAction<Partial<IDialogState>>) {
      return {
        ...state,
        ...action.payload,
        show: true,
      };
    },

    closeDialog(): IDialogState {
      return initialState;
    },
  },
});

// biome-ignore lint/nursery/useExplicitType: Redux Toolkit action creators are inferred
export const { openDialog, closeDialog } = DialogSlice.actions;

export default DialogSlice.reducer;
